import React, { useState } from 'react';
import { t } from '@lingui/macro';

import OnOffSwitch from '@rover/components/src/buttons/OnOffSwitch';
import { Button, Paragraph, Text } from '@rover/kibble/core';
import Row from '@rover/kibble/patterns/Row';
import useTheme from '@rover/kibble/themes/useTheme';
import BottomInfoModal from '@rover/react-lib/src/components/modals/BottomInfoModal';
import { RECURRING_SWITCH_TEXT } from '@rover/react-lib/src/pages/contact-sitter/ContactSitterPage/components/ServiceScheduler/constants';
import {
  StyledInfoIcon,
  ToggleProps,
} from '@rover/react-lib/src/pages/search/SearchPage/components/Filters/Dates/SimplifiedMobileOwnerSearchFormScheduler';

const OneTimeRepeatSwitch = ({ on, onChange }: ToggleProps): JSX.Element => {
  const [isOpen, setIsOpen] = useState(false);
  const theme = useTheme();

  return (
    <>
      <Row
        helperItem={
          <Button
            variant="flat"
            aria-label={t`Learn more about recurring services`}
            onClick={() => setIsOpen(true)}
            sx={{
              backgroundColor: theme.background.primary,
              p: '0x',
            }}
          >
            <StyledInfoIcon />
          </Button>
        }
        label={
          <Text fontWeight="semibold" size="100">
            {RECURRING_SWITCH_TEXT()}
          </Text>
        }
        rightItem={
          <OnOffSwitch
            disabled={false}
            label={RECURRING_SWITCH_TEXT()}
            on={on}
            onToggle={(value): void => onChange(value)}
            hideLabel
          />
        }
      />
      <BottomInfoModal
        heading={t`Weekly bookings`}
        isOpen={isOpen}
        onRequestClose={() => setIsOpen(false)}
        text={
          <>
            <Paragraph size="200" mb="6x">
              {t`Weekly bookings allow you to choose whether you want a booking to repeat automatically every week.`}
            </Paragraph>
            <Paragraph size="200" mb="6x">
              {t`With this feature, bookings take place on the same day of the week and they'll repeat on an ongoing basis. You can discontinue recurring bookings at any time.`}
            </Paragraph>
          </>
        }
        buttonText={t`Got it`}
      />
    </>
  );
};

export default OneTimeRepeatSwitch;
